import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Badge from "react-bootstrap/Badge";
import "./MeetingNote.css";

function MeetingNote({ comment }) {
  return (
    <Col className="comment-container">
      <Row className="justify-content-center align-items-center">
        <Col lg={3}>
          <p className="comment">{comment.userName}</p>
        </Col>
        <Col lg={9}>
          <Badge bg="light" text="dark">
            {comment.message}
          </Badge>
        </Col>
      </Row>
    </Col>
  );
}

export default MeetingNote;
